import React from 'react';
import {Typography} from '@material-ui/core';

import styles from './FeaturesSection.scss';
import CustomGrid from '../../controls/grid/CustomGrid';
import CustomBox from '../../controls/grid/CustomBox';
import FeatureCard from './FeatureCard';
import VideoChatCardIcon from '../../controls/icons/VideoChatCardIcon';
import DirectMessageCardIcon from '../../controls/icons/DirectMessageCardIcon';
import ShareViewCardIcon from '../../controls/icons/ShareViewCardIcon';
import ServicesCardIcon from '../../controls/icons/ServicesCardIcon';
import MembershipCardIcon from '../../controls/icons/MembershipCardIcon';
import DirectImagingCardIcon from '../../controls/icons/DirectImagingCardIcon';
import Divider from 'components/controls/Divider';

export default function FeaturesSection() {
    return (
        <CustomGrid
            container
            justify="center"
            className={styles.container}
        >
            <CustomGrid
                item
                container
                spacing="m"
                xs={12}
                md={6}
            >
                <CustomGrid
                    item
                    xs={12}
                >
                    <CustomBox
                        mt="xxl-3"
                    >
                        <Typography
                            variant="h1"
                            color="primary"
                            align="center"
                        >
                            {loc('features')}
                        </Typography>
                    </CustomBox>
                </CustomGrid>
                <CustomGrid
                    item
                    xs={12}
                >
                    <CustomBox
                        my="xxl"
                    >
                        <Typography
                            variant="h2"
                            align="center"
                        >
                            {loc('features-label')}
                        </Typography>
                    </CustomBox>
                </CustomGrid>
            </CustomGrid>
            <CustomGrid
                item
                container
                spacing="xxl-3"
                md={8}
                xs={12}
                className={styles.wrapper}
            >
                <CustomGrid
                    item
                    container
                    direction="column"
                    md={6}
                    xs={12}
                    spacing="xxl-2"
                >
                    <CustomGrid
                        item
                    >
                        <FeatureCard
                            className={styles.element11}
                            title={loc('video-chat')}
                            text={loc('video-chat-card-text')}
                            Icon={VideoChatCardIcon}
                        />
                    </CustomGrid>
                    <CustomGrid
                        item
                    >
                        <FeatureCard
                            className={styles.element12}
                            title={loc('share-view-card-title')}
                            text={loc('share-view-card-text')}
                            Icon={ShareViewCardIcon}
                        />
                    </CustomGrid>
                    <CustomGrid
                        item
                    >
                        <FeatureCard
                            className={styles.element13}
                            title={loc('membership-card-title')}
                            text={loc('membership-card-text')}
                            Icon={MembershipCardIcon}
                        />
                    </CustomGrid>
                </CustomGrid>
                <CustomGrid
                    item
                    container
                    direction="column"
                    md={6}
                    xs={12}
                    spacing="xxl-2"
                >
                    <CustomGrid
                        item
                    >
                        <FeatureCard
                            className={styles.element21}
                            title={loc('direct-message-card-title')}
                            text={loc('direct-message-card-text')}
                            Icon={DirectMessageCardIcon}
                        />
                    </CustomGrid>
                    <CustomGrid
                        item
                    >
                        <FeatureCard
                            className={styles.element22}
                            title={loc('services-card-title')}
                            text={loc('services-card-text')}
                            Icon={ServicesCardIcon}
                        />
                    </CustomGrid>
                    <CustomGrid
                        item
                    >
                        <FeatureCard
                            className={styles.element23}
                            title={loc('direct-imaging-card-title')}
                            text={loc('direct-imaging-card-text')}
                            Icon={DirectImagingCardIcon}
                        />
                    </CustomGrid>
                </CustomGrid>
            </CustomGrid>

            <CustomGrid
                item
                xs={8}
                className={styles.fullWidth}
            >
                <Divider />
            </CustomGrid>
        </CustomGrid>
    );
}



// WEBPACK FOOTER //
// ./src/components/Index/sections/FeaturesSection.jsx